"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hammingDistance = void 0;
const hammingDistance = (a, b) => {
    let distance = 0;
    while (a != 0 || b != 0) {
        distance += ((a ^ b) & 1);
        a = a >> 1;
        b = b >> 1;
    }
    return distance;
};
exports.hammingDistance = hammingDistance;
//# sourceMappingURL=bit-operations.js.map